import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import { ensureUser } from '../../../util/data';

import { AvatarLarge, NamedLink } from '../../../components';

import css from './SectionHostProfile.module.css';

/**
 * Host profile card shown at the top of the listing page main column.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @param {propTypes.user} props.author
 * @param {string} props.authorDisplayName
 * @param {number|null} props.listingsCount
 * @returns {JSX.Element|null}
 */
const SectionHostProfile = props => {
  const { className, rootClassName, author, authorDisplayName, listingsCount } = props;

  if (!author) {
    return null;
  }

  const ensuredAuthor = ensureUser(author);
  const { createdAt } = ensuredAuthor.attributes || {};
  const memberSinceYear = createdAt ? new Date(createdAt).getFullYear() : null;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <section id="author" className={classes}>
      <div className={css.card}>
        <AvatarLarge className={css.avatar} user={author} />
        <div className={css.info}>
          <div className={css.hostedByContainer}>
            <p className={css.hostedBy}>
              <FormattedMessage
                id="ListingPage.hostedBy"
                values={{ name: <span className={css.hostName}>{authorDisplayName}</span> }}
              />
            </p>
            {ensuredAuthor.id ? (
              <NamedLink className={css.viewProfileLink} name="ProfilePage" params={{ id: ensuredAuthor.id.uuid }}>
                <FormattedMessage id="UserCard.viewProfileLink" />
              </NamedLink>
            ) : null}
          </div>

          <div className={css.meta}>
            {memberSinceYear ? (
              <span className={css.metaItem}>
                <FormattedMessage id="ListingPage.memberSince" values={{ year: memberSinceYear }} />
              </span>
            ) : null}
            {typeof listingsCount === 'number' ? (
              <span className={css.metaItem}>
                <FormattedMessage id="ListingPage.listingsCount" values={{ count: listingsCount }} />
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHostProfile;
